
import {
	Component,
	Vue,
	Watch
} from 'vue-property-decorator';
import PageFooter from '@/components/page-footer.vue';
import Dialog from '@/components/dialog.vue';
import {
	orderDailyAnalysisList
} from '@/api/orderDailyAnalysis';
import {
	getSearchDate,
	nextDay
} from "@/utils/index"

@Component({
	name: 'order-daily-analysis',
	components: {
		PageFooter,
		'slz-dialog': Dialog,
	}
})
export default class OrderDailyAnalysis extends Vue {
	private startTime = '00:00:00'
	private endTime = '23:59:59'
	private list: any[] = [];
	private pageNo = 1;
	private pageSize = 10;
	private total = 0;
	private tableloading = false

	// 导出相关
	private exportDialogVisible = false
	private exportStartTime = '00:00:00'
	private exportEndTime = '23:59:59'
	private exportDateRange: any = []

	@Watch('startTime')
	private onStartTimeChange(val: string) {
		if (val && this.endTime && this.endTime < val) {
			this.endTime = val
		}
	}

	private mounted() {
		this.getList()
	}

	private changePage(e: number) {
		this.pageNo = e
		this.getList()
	}

	private async getList() {
		let param: any = {
			Skip: (this.pageNo - 1) * this.pageSize,
			Take: this.pageSize,
			StartTimePoint: this.startTime || '00:00:00',
			EndTimePoint: this.endTime || '23:59:59'
		}

		try {
			this.tableloading = true
			const res: any = await orderDailyAnalysisList(param);
			this.list = res.Result.Results || [];
			this.total = res.Result.Total || 0;
		} catch (e) {
			console.log(e)
		} finally {
			this.tableloading = false
		}
	}

	private doSearch() {
		this.pageNo = 1;
		this.getList();
	}

	private handleExport() {
		this.exportStartTime = this.startTime
		this.exportEndTime = this.endTime
		this.exportDialogVisible = true
	}

	private confirmExport() {
		if (!this.exportStartTime || !this.exportEndTime) {
			this.$message.warning('请选择时间段')
			return
		}
		// 验证结束时间不能早于开始时间
		if (this.exportEndTime < this.exportStartTime) {
			this.$message.warning('结束时间不能早于开始时间')
			return
		}
		if (!this.exportDateRange || this.exportDateRange.length < 2) {
			this.$message.warning('请选择导出日期')
			return
		}

		// 计算日期跨度
		const startDate = new Date(this.exportDateRange[0])
		const endDate = new Date(this.exportDateRange[1])
		const daysDiff = Math.floor((endDate.getTime() - startDate.getTime()) / (1000 * 60 * 60 * 24))
		if (daysDiff >= 92) {
			this.$message.warning('日期跨度不能超过92天')
			return
		}

		let url = location.origin + '/pc/orderDailyAnalysis/export' +
			'?StartTimePoint=' + (this.exportStartTime || '') +
			'&EndTimePoint=' + (this.exportEndTime || '') +
			'&StartTime=' + (this.exportDateRange[0] || '') +
			'&EndTime=' + (this.exportDateRange[1] || '')

		window.open(url)
		this.exportDialogVisible = false
	}
}
